module.exports = __webpack_public_path__ + "static/media/logo.e5b093f0.png";